<template>
	<component :is="tag" :class="cls" class="api-error">
		<sym-icon v-if="icon" :name="icon"></sym-icon>
		<div v-if="html" class="readable" v-html="message"></div>
		<div v-else class="readable">{{ message }}</div>
		<it-link v-for="a in actions" class="fi-action input-height" :class="a.class" :to="a.link">{{ a.label }}</it-link>
	</component>
</template>

<script setup lang="ts">
import {computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {ApiErrorAction, ErrorLevel} from "@t/util/ApiError.ts";
import ItLink from "@/router/ItLink.vue";

const props = withDefaults(defineProps<{
	level: ErrorLevel,
	message: string,
	icon?: string,
	tag?: string,
	html?: boolean,
	actions?: ApiErrorAction[]
}>(), { tag: "div", actions: () => [], html:false });

const cls = computed(() => {
   const c:string[] = ["fd-message"];
   if ("SEVERE" === props.level) c.push("fd-error");
   else if ("WARNING" === props.level) c.push("fd-warning");
   else if ("NOTE" === props.level) c.push("fd-note");
   else c.push("fd-info");
   return c;
});
</script>

<style>
.api-error {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	column-gap: 4px;
}
.fd-message {
	border-left: 1px solid var(--fg);
	background-color: var(--bg);
	color: var(--fg);
	padding: 2px 5px;
	font-size: var(--font-size-s);

	& .fi {
		font-size: var(--font-size);
	}
}
.fd-message.no-border {
	border-left: none;
}
.form-error-body {
	/* This is a global error and should use bigger font */
	& > .fd-message {
		font-size: var(--font-size);
		padding-block: 5px;
	}
}
.fd-error {
	--border-color: var(--error-fg);
	--fg: var(--error-fg);
	--bg: var(--error-bg);
}
.fd-warning {
	--border-color: var(--warn-fg);
	--fg: var(--warn-fg);
	--bg: var(--warn-bg);
}
.fd-info {
	--border-color: var(--info-fg);
	--fg: var(--info-fg);
	--bg: var(--info-bg);
}
.fd-note {
	--border-color: var(--note-fg);
	--fg: var(--notify-fg);
	--bg: var(--notify-bg);
	position: relative;

	&::before {
		content: '';
		background-color: var(--fg);
		width: 4px;
		top: 2px;
		bottom: 2px;
		position: absolute;
		left: 2px;
		border-radius: 2px;
		opacity: 0.5;
	}
}
</style>